import React, { useEffect, useState } from "react";
import { Modal, Form, InputGroup } from "react-bootstrap";
import "./styleModal.css";
import moment from "moment";
import { LINEAR_GRADIENT_BG } from "../const";
import { toast } from "react-toastify";

export default function CurrentDateComponents({
  openModal,
  onCloseModal,
  setCdFillter,
  setActiveButton,
  activeButton,
}) {
  // default this month
  let defaultStartMonth = moment().startOf("month").format("YYYY-MM-DD");
  let defaultEndMonth = moment().endOf("month").format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(defaultStartMonth);
  const [endDate, setEndDate] = useState(defaultEndMonth);

  useEffect(() => {
    if(activeButton === "thisMonth") {
      setCdFillter({
        createdAt_gte: defaultStartMonth,
        createdAt_lt: defaultEndMonth,
      });
    }
    if (activeButton === "today") {
      onSelectDayBox("today");
    }
    if (activeButton === "thisYear") {
      onSelectDayBox("thisYear");
    }
  }, [defaultStartMonth, defaultEndMonth]);

  const getStartDate = (filter) => {
    switch (filter) {
      case "today":
        return moment().startOf("day").toISOString();
      case "yesterday":
        return moment().subtract(1, "day").startOf("day").toISOString();
      case "thisWeek":
        return moment().startOf("week").toISOString();
      case "lastWeek":
        return moment().subtract(1, "week").startOf("week").toISOString();
      case "thisMonth":
        return moment().startOf("month").toISOString();
      case "lastMonth":
        return moment().subtract(1, "month").startOf("month").toISOString();
      case "thisYear":
        return moment().startOf("year").toISOString();
      case "lastYear":
        return moment().subtract(1, "year").startOf("year").toISOString();
      default:
        return null;
    }
  };

  const getEndDate = (filter) => {
    switch (filter) {
      case "today":
        return moment().endOf("day").toISOString();
      case "yesterday":
        return moment().subtract(1, "day").endOf("day").toISOString();
      case "thisWeek":
        return moment().endOf("week").toISOString();
      case "lastWeek":
        return moment().subtract(1, "week").endOf("week").toISOString();
      case "thisMonth":
        return moment().endOf("month").toISOString();
      case "lastMonth":
        return moment().subtract(1, "month").endOf("month").toISOString();
      case "thisYear":
        return moment().endOf("year").toISOString();
      case "lastYear":
        return moment().subtract(1, "year").endOf("year").toISOString();
      default:
        return null;
    }
  };

  const convertCurrentDate = (data) => {
    const thaiTimezone = moment(data).tz("Asia/Bangkok").format("MM/DD/YYYY");

    return thaiTimezone;
  };

  const onChangeStartDate = (e) => {
    setStartDate(e?.target?.value);
  };
  const onChangeEndDate = (e) => {
    setEndDate(e?.target?.value);
  };
  const onCloseElementAll = () => {
    onCloseModal();
  };

  const onSaveMyCurrentDate = () => {
    if(!startDate) {
      toast.warning("ກະລຸນາເລືອກວັນທີກ່ອນ...")
    }else {
      onCloseModal();
      setStartDate()
      setEndDate()
      setCdFillter({
        createdAt_gte: startDate,
        createdAt_lt: endDate,
    });
  }

  };

  const onSelectDayBox = async (data) => {
    setActiveButton(data);
    const _startDate = await getStartDate(data);
    const _endDate = await getEndDate(data);
    console.log(_startDate, _endDate);
    await setCdFillter({
      createdAt_gte: _startDate,
      createdAt_lt: _endDate,
    });
    await onCloseModal();
  };

  

  const isActive = {
    cursor: "pointer",
  };

  const active = {
    background: LINEAR_GRADIENT_BG,
    cursor: "pointer",
    color: "#FFFFFF",
  };

  return (
    <Modal centered show={openModal}>
      <Modal.Header>
        <Modal.Title
          style={{
            fontSize: 18,
            paddingTop: 10,
            width: "100%",
            textAlign: "center",
          }}
        >
          {!startDate ? (
            "ຂໍ້ມູນທີ່ທ່ານເລືອກ"
          ) : (
            <>
              {convertCurrentDate(startDate) +
                " - " +
                convertCurrentDate(endDate)}
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card-input-date">
          <InputGroup className="mb-3">
            <Form.Control
              value={startDate}
              onChange={(e) => onChangeStartDate(e)}
              size="sm"
              type="date"
              aria-label="startDate"
            />
            <InputGroup.Text>ຫາ</InputGroup.Text>
            <Form.Control
              size="sm"
              value={endDate}
              onChange={(e) => onChangeEndDate(e)}
              type="date"
              aria-label="endDate"
            />
          </InputGroup>
        </div>

        <div className="card-day-select">
          <div
            style={activeButton === "today" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("today")}
          >
            ມື້ນີ້
          </div>
          <div
            style={activeButton === "yesterday" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("yesterday")}
          >
            ມື້ວານນີ້
          </div>
          <div
            style={activeButton === "thisWeek" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisWeek")}
          >
            ອາທິດນີ້
          </div>
          <div
            style={activeButton === "lastWeek" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastWeek")}
          >
            ອາທິດກ່ອນ
          </div>
          <div
            style={activeButton === "thisMonth" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisMonth")}
          >
            ເດືອນນີ້
          </div>
          <div
            style={activeButton === "lastMonth" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastMonth")}
          >
            ເດືອນກ່ອນ
          </div>
          <div
            style={activeButton === "thisYear" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisYear")}
          >
            ປີນີ້
          </div>
          <div
            style={activeButton === "lastYear" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastYear")}
          >
            ປີທີ່ແລ້ວ
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ border: "none" }}>
        <div style={{ display: "flex", gap: 10, width: "100%" }}>
          <button className="btn-cancel-date" onClick={onCloseElementAll}>
            ຍົກເລີກ
          </button>
          <button className="btn-save-date" onClick={onSaveMyCurrentDate}>
            ຢືນຢັນ
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
